"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MotionPoint = /** @class */ (function () {
    function MotionPoint() {
    }
    MotionPoint.prototype.languageClick = function (e) {
        e.preventDefault();
        this.changeLocale(e);
        var url = 'https://e-tst1.stage.att.com/es-us/';
        var lang = e.currentTarget.getAttribute('data-lang');
        MP.tSite = 'e-tst1.stage.att.com';
        MP.oSite = 'e-tst1.stage.att.com';
        MP.UrlLang = window.location.href.indexOf('es-us') !== -1 ? 'es' : 'en';
        MP.switchLanguage(MP.tSite === url ? MP.oSite : url, lang);
    };
    MotionPoint.prototype.init = function () {
        var gnsessCookie = this.getCookie('GNSESS');
        if (gnsessCookie && gnsessCookie !== 'null' && gnsessCookie !== '' && gnsessCookie !== 'undefined') {
            this.localLanguage = '' + JSON.parse(gnsessCookie).LOCALE;
            if (this.localLanguage) {
                if (window.location.href.indexOf('es-us') !== -1 && this.localLanguage === 'es_US') {
                    // User is on a Spanish language page so no redirect is necessary
                }
                else if (!(window.location.href.indexOf('es-us') !== -1) && this.localLanguage === 'es_US') {
                    // User is on english page, but they perfer Spanish, so redirect
                    // User is on an English page so redirect to Spanish
                    var $this = document.getElementsByClassName('.langLink');
                    var mpUrl = $this && $this[0] ? $this[0].getAttribute('data-href') : 'https://www.att.com';
                    var mpLang = $this && $this[0] ? $this[0].getAttribute('data-lang') : 'en-us';
                    MP.switchLanguage(MP.tSite === mpUrl ? MP.oSite : mpUrl, mpLang);
                }
            }
        }
    };
    MotionPoint.prototype.getCookie = function (cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        var cookieValue = '';
        ca.map(function (cookie) {
            var c = cookie;
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                cookieValue = c.substring(name.length, c.length);
            }
        });
        return cookieValue;
    };
    /*assumption that else case will not be triggered as GNSESS cookie will always be present*/
    /*else {
        GE5P.teslaGNSESSCookie(localLanguage);
    }*/
    MotionPoint.prototype.updateGNSESSCookie = function (locale, requesturl, mpUrl, mpLang) {
        var locale2;
        if (locale === 'en_US') {
            locale2 = 'es_US';
        }
        else {
            locale2 = 'en_US';
        }
        var GNSESSObj = JSON.parse(this.getCookie('GNSESS'));
        var newObj = {};
        if (GNSESSObj) {
            newObj = GNSESSObj;
            if (GNSESSObj.LOCALE) {
                newObj.LOCALE = locale2;
            }
            var name_1 = 'GNSESS';
            var days = '';
            var path = '/';
            var domain = '.att.com';
            this.setCookie(name_1, newObj, domain, path, days);
        }
    };
    MotionPoint.prototype.setCookie = function (cname, cvalue, domain, path, days) {
        document.cookie = cname + '=' + JSON.stringify(cvalue) + ';' +
            'domain = ' + domain + ';' + 'path = ' + path + ';' + 'days = ' + days;
    };
    MotionPoint.prototype.changeLocale = function (RefThis) {
        var targetRefThis = RefThis.currentTarget;
        var requesturl = targetRefThis.getAttribute('href');
        var mpUrl = targetRefThis.getAttribute('data-href');
        var mpLang = targetRefThis.getAttribute('data-lang');
        var locale = this.localLanguage;
        if (locale) {
            // Cookie exists so update
            // if (GE5P.ge5p_motionpoint) {
            // Update cookie only
            // requesturl = 'motionpoint';
            // }
            this.updateGNSESSCookie(locale, requesturl, mpUrl, mpLang);
        }
        else {
            /*assumption that else case will not be triggered as GNSESS cookie will always be present*/
        }
        return false;
    };
    return MotionPoint;
}());
exports.default = MotionPoint;
//# sourceMappingURL=MotionPoint.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/cards/FooterLinks/MotionPoint.js
// module id = 1386
// module chunks = 8